// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { useMutation } from "redux-query-react";
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { ExportDataDownloadRequestToJSON, ExportDataDownloadResponseFromJSON, ExportDataExcelHistoryFromJSON, ExportDataExcelHistoryDocumentResponseFromJSON, ExportDataExcelRequestToJSON, } from '../models';
/**
 * Excel export history list
 * Gets excel export history list by entity kind
 */
export function getExportDataExcelHistoryRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.entityKind === null || requestParameters.entityKind === undefined) {
        throw new runtime.RequiredError('entityKind', 'Required parameter requestParameters.entityKind was null or undefined when calling getExportDataExcelHistory.');
    }
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/export-data/{entityKind}/excel/history`.replace(`{${"entityKind"}}`, encodeURIComponent(String(requestParameters.entityKind))) + queryString,
        meta,
        update: requestConfig.update || {
            ExportData: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = body.map(ExportDataExcelHistoryFromJSON);
            return {
                ExportData: objResponse.reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {})
            };
        }
    };
    config.queryKey = requestConfig.queryKey || `GetExportDataExcelHistory-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Excel export history list
* Gets excel export history list by entity kind
*/
export function getExportDataExcelHistory(requestParameters, requestConfig) {
    return getExportDataExcelHistoryRaw(requestParameters, requestConfig);
}
/**
 * Excel export history document
 * Gets data excel export history document
 */
export function getExportDataExcelHistoryDocumentRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.id === null || requestParameters.id === undefined) {
        throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getExportDataExcelHistoryDocument.');
    }
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/export-data/excel/history/document/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))) + queryString,
        meta,
        update: requestConfig.update || {
            ExportData: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = ExportDataExcelHistoryDocumentResponseFromJSON(body);
            if (body.id) {
                return { ExportData: { [objResponse.id]: objResponse } };
            }
            if (body.data && body.total && requestConfig.queryKey) {
                return { ExportData: { [requestConfig.queryKey]: objResponse } };
            }
            return {};
        }
    };
    config.queryKey = requestConfig.queryKey || `GetExportDataExcelHistoryDocument-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Excel export history document
* Gets data excel export history document
*/
export function getExportDataExcelHistoryDocument(requestParameters, requestConfig) {
    return getExportDataExcelHistoryDocumentRaw(requestParameters, requestConfig);
}
/**
 * downloads a excel
 * Download export
 */
export function postExportDataDownloadRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/export-data/download-export` + queryString,
        meta,
        update: requestConfig.update || {
            ExportData: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: ExportDataDownloadRequestToJSON(requestParameters.exportDataDownloadRequest),
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = ExportDataDownloadResponseFromJSON(body);
            if (body.id) {
                return { ExportData: { [objResponse.id]: objResponse } };
            }
            if (body.data && body.total && requestConfig.queryKey) {
                return { ExportData: { [requestConfig.queryKey]: objResponse } };
            }
            return {};
        }
    };
    config.queryKey = requestConfig.queryKey || `PostExportDataDownload-${objectToHash(requestParameters)}`;
    return config;
}
/**
* downloads a excel
* Download export
*/
/**
 * Mutation hook to upsert an ExportDataDownloadResponse
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to upsert an ExportDataDownloadResponse
 */
export const usePostExportDataDownload = (customQueryConfig) => {
    return useMutation((exportDataDownloadRequest, customQueryParam) => postExportDataDownloadRaw({ exportDataDownloadRequest }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function postExportDataDownload(requestParameters, requestConfig) {
    return postExportDataDownloadRaw(requestParameters, requestConfig);
}
/**
 * Exports Excel document with a POST to avoid GETs with bodies
 * Exports granular data to Excel document
 */
export function postExportDataExcelRaw(requestParameters, requestConfig = {}) {
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    headerParameters['Content-Type'] = 'application/json';
    const { meta = {} } = requestConfig;
    const config = {
        url: runtime.BASE_PATH + `/export-data/excel` + queryString,
        meta,
        update: requestConfig.update || {
            ExportData: (prevValue, transformedValue) => {
            }
        },
        optimisticUpdate: requestConfig.optimisticUpdate || {
            ExportData: (prevValue) => {
            }
        },
        rollback: requestConfig.rollback || {
            ExportData: (initialValue, currentValue) => {
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'POST',
            headers: headerParameters,
        },
        body: ExportDataExcelRequestToJSON(requestParameters.exportDataExcelRequest),
    };
    config.queryKey = requestConfig.queryKey || `PostExportDataExcel-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Exports Excel document with a POST to avoid GETs with bodies
* Exports granular data to Excel document
*/
/**
 * Mutation hook to upsert an
 * @param customQueryConfig TypedQueryConfig options set here will override default options.
 * @returns [QueryState, RunMutation] queryState and an async call to upsert an
 */
export const usePostExportDataExcel = (customQueryConfig) => {
    return useMutation((exportDataExcelRequest, customQueryParam) => postExportDataExcelRaw({ exportDataExcelRequest }, { ...customQueryConfig, meta: { ...customQueryConfig?.meta, ...customQueryParam } }));
};
export function postExportDataExcel(requestParameters, requestConfig) {
    return postExportDataExcelRaw(requestParameters, requestConfig);
}
